// removed by extract-text-webpack-plugin
module.exports = {"text-container":"src-pages----legal-page-module---text-container---240-5","title":"src-pages----legal-page-module---title---3uNVd","preamble":"src-pages----legal-page-module---preamble---3Ya-u","h3":"src-pages----legal-page-module---h3---3WZH8","h4":"src-pages----legal-page-module---h4---1ow7k"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/legal-page.module.scss
// module id = 207
// module chunks = 15400075347947 143394374220347